<template>
  <div class="group">
    <el-col :span="Number($attrs.config.grid)">
      <el-form-item :label="pNode.label" :prop="pNode.post">
        <el-radio-group v-model="$attrs.model[pNode.post]">
          <el-radio v-for="(radio, index) in pNode.options.valueData" :key="index" :label="radio.value" :disabled="pNode.options.disabled">{{ radio.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-col>
    <template v-if="$attrs.model[pNode.post] == '2'">
      <el-col :span="Number($attrs.config.grid)" v-for="(cNode, idx) of childList" :key="idx">
        <el-form-item :label="cNode.label" :prop="cNode.post" :rules="[{ required: true, message: '请输入必填项', trigger: 'blur' }]">
          <el-input
            v-model="$attrs.model[cNode.post]"
            :ref="cNode.post"
            :placeholder="cNode.options.placeholder"
            :style="{ width: cNode.options.width }"
            :disabled="cNode.options.disabled"
            :clearable="cNode.options.clearable"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {
    pNode() {
      return this.item["list"][0];
    },
    childList() {
      return this.item["list"].slice(1);
    },
  },

  methods: {},
};
</script>

<style lang="scss" scoped></style>
